// Generated payment guard from convex/lib/suriSecurity.ts
"use strict";
var SuriAvaSecurity = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // convex/lib/suriSecurity.ts
  var suriSecurity_exports = {};
  __export(suriSecurity_exports, {
    GREETING: () => GREETING,
    SECURITY_MARKER: () => SECURITY_MARKER,
    paymentDisclosure: () => paymentDisclosure,
    securityReply: () => securityReply
  });
  var SECURITY_MARKER = "[Payment details removed; session ended for security]";
  var GREETING = "Hi, this is Ava your customer service assistant for Suri, how can I help you?";
  var securityReply = (voice = false) => `Apologies, for security reasons, I need to end this ${voice ? "call" : "chat"}. Please don't share bank account or credit card information. Use Suri's secure website checkout to place an order.`;
  var digitWords = { zero: "0", oh: "0", one: "1", two: "2", three: "3", four: "4", five: "5", six: "6", seven: "7", eight: "8", nine: "9" };
  function paymentDisclosure(value) {
    const text = value.normalize("NFKC").toLowerCase().replace(/[\u200b-\u200f\u202a-\u202e\u2060-\u206f]/g, "");
    const normalized = text.replace(/\b(zero|oh|one|two|three|four|five|six|seven|eight|nine)\b/g, (word) => digitWords[word]);
    if (/(?:\d[\s,.\-]*){13,19}/.test(normalized)) return true;
    if (/\b[a-z]{2}\s*\d{2}(?:[\s-]*[a-z0-9]){11,30}\b/i.test(text)) return true;
    const label = "(?:credit[ -]?card|debit[ -]?card|card(?: number)?|bank(?: account)?|account number|routing(?: number)?|iban|cvv|cvc|security code|card pin)";
    if (new RegExp(`\\b(?:my|the) ${label}(?: number| details)?\\s*(?:is|are|:|=)\\s*(?:\\d|$)`, "i").test(normalized)) return true;
    if (new RegExp(`\\b${label}\\b\\s*(?:(?:number|is|are|:|=)\\s*){0,3}\\d[\\d\\s,.\\-]{1,}`, "i").test(normalized)) return true;
    if (new RegExp(`(?:\\d[\\s,.\\-]*){3,}.{0,25}\\b(?:is my|for my) ${label}`, "i").test(normalized)) return true;
    return false;
  }
  return __toCommonJS(suriSecurity_exports);
})();

(() => {
  'use strict';
  if (customElements.get('suri-ava-chat')) return;
  const HELLO = "Hi, this is Ava your customer service assistant for Suri, how can I help you?";
  const QUESTIONS = [
    ['Find a piece', 'Can you help me choose a piece of Suri jewelry?'],
    ['Sizing & fit', 'How can I find the right size for Suri jewelry?'],
    ['Jewelry care', 'How should I care for my Suri jewelry?'],
    ['Shipping & returns', 'What are your shipping and return policies?']
  ];
  const TITLES = { 'shipping-return-policy': 'Shipping & returns', 'suri-rewards': 'Suri Rewards', contact: 'Contact Suri', 'about-us': 'Our story', personalized: 'Personalized jewelry', blogs: 'Jewelry care', 'privacy-policy': 'Privacy policy' };
  // Per-tab storage keeps the conversation across page loads; it clears when the tab closes.
  const SAVED = 'suri-ava-chat-v1';
  const MAX_SAVED = 39;
  const NETWORK_GRACE = 1500;
  const POLL_FAST = 500, POLL_FAST_COUNT = 20, POLL_SLOW = 1000;
  const icon = (path) => `<svg viewBox="0 0 24 24" aria-hidden="true">${path}</svg>`;
  const chat = icon('<path d="M20 11.5a8 8 0 0 1-8 8H5l-4 3v-11a9 9 0 1 1 19 0Z"/><path d="M7 10h8M7 14h5"/>');

  class AvaChat extends HTMLElement {
    connectedCallback() {
      if (this.shadowRoot) return;
      this.attachShadow({ mode: 'open' });
      this.session = null;
      this.busy = false;
      this.pending = false;
      this.leaving = false;
      this.generation = 0;
      this.endedForSecurity = false;
      this.abort = null;
      this.transcript = [];
      this.endpoint = this.dataset.endpoint;
      this.shadowRoot.innerHTML = `
        <link rel="stylesheet">
        <section id="ava-panel" class="panel" role="dialog" aria-label="Chat with Ava, Suri AI assistant" hidden>
          <header class="header">
            <span class="avatar" aria-hidden="true"><img width="64" height="24" alt="" decoding="async"></span>
            <div class="identity"><h2 class="name">Ava</h2><p class="subtitle">Your Suri jewelry assistant · AI</p></div>
            <button class="icon-button close" type="button" aria-label="Close chat">${icon('<path d="m6 6 12 12M18 6 6 18"/>')}</button>
          </header>
          <div class="messages" role="log" aria-label="Conversation with Ava" aria-live="polite" aria-relevant="additions" tabindex="0"></div>
          <div class="status" role="status" aria-live="polite"></div>
          <footer class="footer">
            <form class="composer">
              <label class="sr-only" for="ava-question">Your question about Suri</label>
              <input id="ava-question" type="text" maxlength="1000" placeholder="Ask about Suri…" autocomplete="off" enterkeyhint="send" required>
              <button class="send" type="submit" aria-label="Send message">${icon('<path d="M12 19V5m-6 6 6-6 6 6"/>')}</button>
            </form>
            <p class="privacy">Suri saves conversation text for 90 days to review and improve support. Please don’t share payment details or passwords. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy</a></p>
            <div class="utility"><a href="/pages/contact">Contact the Suri team</a><button class="reset" type="button">New chat</button></div>
          </footer>
        </section>
        <button class="launcher" type="button" aria-expanded="false" aria-controls="ava-panel" aria-haspopup="dialog" aria-label="Chat with Ava">${chat}<span>Chat with Ava</span></button>`;
      this.shadowRoot.querySelector('link').href = this.dataset.stylesheet;
      this.shadowRoot.querySelector('.avatar img').src = this.dataset.logo;
      for (const [name, selector] of Object.entries({ panel: '.panel', launcher: '.launcher', input: 'input', log: '.messages', status: '.status', send: '.send', reset: '.reset', closeButton: '.close' })) this[name] = this.shadowRoot.querySelector(selector);
      this.launcher.addEventListener('click', () => this.toggle(this.panel.hidden));
      this.closeButton.addEventListener('click', () => this.toggle(false));
      this.shadowRoot.querySelector('form').addEventListener('submit', (event) => { event.preventDefault(); this.submit(); });
      this.reset.addEventListener('click', () => this.clear());
      this.shadowRoot.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.panel.hidden) { event.preventDefault(); this.toggle(false); }
      });
      if (!this.restore()) this.welcome();
      this.setupDragging();
      this.onPageHide = () => this.leave();
      this.onPageShow = (event) => { if (event.persisted) this.returned(); };
      window.addEventListener('pagehide', this.onPageHide);
      window.addEventListener('pageshow', this.onPageShow);
      this.place = () => this.updatePlacement();
      this.schedulePlacement = () => {
        if (this.placementTimer) return;
        this.placementTimer = setTimeout(() => { this.placementTimer = null; this.updatePlacement(); }, 200);
      };
      this.teaserObserver = new MutationObserver(this.schedulePlacement);
      this.discoveryObserver = new MutationObserver(this.schedulePlacement);
      this.discoveryObserver.observe(document.body, { childList: true, subtree: true });
      window.addEventListener('resize', this.place);
      this.shadowRoot.querySelector('link').addEventListener('load', this.place);
      this.updatePlacement();
    }

    disconnectedCallback() {
      this.onPageHide?.();
      this.stopLoading();
      this.dragEvents?.abort();
      this.abort?.abort();
      window.removeEventListener('pagehide', this.onPageHide);
      window.removeEventListener('pageshow', this.onPageShow);
      window.removeEventListener('resize', this.place);
      this.discoveryObserver?.disconnect(); this.teaserObserver?.disconnect();
      clearTimeout(this.placementTimer);
    }

    // Leaving the page keeps the server session so the next page can continue it;
    // it expires on its own deadline. Requests the browser aborts while leaving are not errors.
    leave() {
      this.leaving = true;
      this.saveState();
    }

    // The back/forward cache restored this page. Another page in this tab may have continued
    // or cleared the conversation since, so reload the saved copy instead of this page's own.
    returned() {
      this.leaving = false;
      const saved = this.readSaved();
      if (!saved) {
        // Without storage this page's copy is the only one; release a composer left busy while hidden.
        if (this.busy && !this.exchanging) this.setBusy(false);
        return;
      }
      this.generation++;
      this.abort?.abort();
      this.exchanging = false;
      if (this.restore(saved)) return;
      this.session = null; this.pending = false; this.endedForSecurity = false;
      this.setBusy(false);
      this.welcome();
    }

    saveState() {
      try {
        if (!this.transcript.length && !this.session) { sessionStorage.removeItem(SAVED); return; }
        sessionStorage.setItem(SAVED, JSON.stringify({ session: this.session, transcript: this.transcript, pending: Boolean(this.pending && this.session), endedForSecurity: this.endedForSecurity, open: !this.panel.hidden }));
      } catch { /* Without storage the chat still works; it just starts fresh on the next page. */ }
    }

    // Returns null when storage is unavailable, otherwise the saved conversation (or null value).
    readSaved() {
      try { return { value: JSON.parse(sessionStorage.getItem(SAVED)) }; } catch { return null; }
    }

    restore(saved = this.readSaved()) {
      const state = saved?.value;
      if (!state || !Array.isArray(state.transcript) || !state.transcript.length) return false;
      const session = state.session;
      this.session = session && typeof session.token === 'string' && Number.isSafeInteger(session.turn) && Number(session.expires) > Date.now() ? { token: session.token, turn: session.turn, expires: Number(session.expires) } : null;
      // Keep a reply that is still pending marked as such until it is collected.
      this.pending = state.pending === true && Boolean(this.session);
      this.endedForSecurity = state.endedForSecurity === true;
      this.transcript = [];
      this.log.replaceChildren();
      this.message('assistant', HELLO, [], false);
      for (const entry of state.transcript.slice(-MAX_SAVED)) {
        if (entry && ['user', 'assistant', 'notice'].includes(entry.role) && typeof entry.text === 'string') this.message(entry.role, entry.text, Array.isArray(entry.sources) ? entry.sources : []);
      }
      this.setBusy(false);
      if (this.panel.hidden === (state.open === true)) this.toggle(state.open === true, false);
      this.saveState();
      if (this.pending) this.resume();
      return true;
    }

    pageContext() {
      // Product pages tell Ava which piece "this" or "it" means.
      const match = /\/products\/([a-z0-9][a-z0-9-]{0,99})(?:[/?#]|$)/i.exec(window.location?.pathname || '');
      return match ? { product: match[1].toLowerCase() } : {};
    }

    updatePlacement() {
      if (this.savedPosition) { this.restorePosition(); return; }
      this.fitPanel();
      const teaser = document.querySelector('[data-testid="animated-teaser"]');
      if (teaser !== this.observedTeaser) {
        this.teaserObserver.disconnect();
        this.observedTeaser = teaser;
        if (teaser) this.teaserObserver.observe(teaser, { attributes: true, childList: true, subtree: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
      }
      let offset = 0;
      if (teaser && getComputedStyle(teaser).visibility !== 'hidden') {
        const launcher = this.launcher.getBoundingClientRect();
        const bounds = teaser.getBoundingClientRect();
        const crossesLeftCorner = bounds.left < launcher.right + 12 && bounds.right > launcher.left;
        for (const element of [teaser, ...teaser.querySelectorAll('[role="button"],button')]) {
          const rect = element.getBoundingClientRect();
          if (crossesLeftCorner && rect.width > 0 && rect.height > 0 && rect.top > innerHeight / 2 && rect.top < innerHeight) offset = Math.max(offset, innerHeight - rect.top + 12);
        }
      }
      const value = `${Math.ceil(offset)}px`;
      if (this.style.getPropertyValue('--ava-obstruction') !== value) this.style.setProperty('--ava-obstruction', value);
    }

    setupDragging() {
      this.dragEvents = new AbortController();
      const options = { signal: this.dragEvents.signal }, style = document.createElement("style");
      style.textContent = ".launcher{touch-action:none;user-select:none;-webkit-user-select:none;cursor:grab}.launcher[data-dragging]{cursor:grabbing}:host{left:auto;right:24px;max-width:calc(100vw - 32px)}@media(max-width:600px){:host{right:16px}}.launcher{max-width:100%}", this.shadowRoot.append(style), this.launcher.title = "Drag to move. Keyboard: Alt + arrow keys.", this.launcher.setAttribute("aria-description", "Drag to move, or use Alt plus arrow keys when focused.");
      try {
        const saved = JSON.parse(localStorage.getItem("suri-ava-position-v2"));
        saved && Number.isFinite(saved.x) && Number.isFinite(saved.y) && saved.x >= 0 && saved.x <= 1 && saved.y >= 0 && saved.y <= 1 && (this.savedPosition = saved);
      } catch {
      }
      this.launcher.addEventListener("click", (event) => {
        this.suppressDragClick && event.detail !== 0 && (event.preventDefault(), event.stopImmediatePropagation(), this.suppressDragClick = false);
      }, { ...options, capture: true }), this.launcher.addEventListener("pointerdown", (event) => {
        if (!event.isPrimary || event.button !== 0) return;
        this.suppressDragClick = false;
        const rect = this.launcher.getBoundingClientRect();
        this.dragStart = { id: event.pointerId, x: event.clientX, y: event.clientY, left: rect.left, top: rect.top, moved: false }, this.launcher.setPointerCapture(event.pointerId);
      }, options), this.launcher.addEventListener("pointermove", (event) => {
        const start = this.dragStart;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x, dy = event.clientY - start.y;
        !start.moved && Math.hypot(dx, dy) < 8 || (start.moved = true, event.preventDefault(), this.launcher.setAttribute("data-dragging", ""), this.moveLauncher(start.left + dx, start.top + dy, true));
      }, options);
      const finish = (event) => {
        const start = this.dragStart;
        !start || start.id !== event.pointerId || (this.dragStart = null, this.launcher.removeAttribute("data-dragging"), start.moved && (this.suppressDragClick = true, this.savePosition()), this.launcher.hasPointerCapture(event.pointerId) && this.launcher.releasePointerCapture(event.pointerId));
      };
      for (const name of ["pointerup", "pointercancel", "lostpointercapture"]) this.launcher.addEventListener(name, finish, options);
      this.launcher.addEventListener("keydown", (event) => {
        const directions = { ArrowLeft: [-20, 0], ArrowRight: [20, 0], ArrowUp: [0, -20], ArrowDown: [0, 20] };
        if (!event.altKey || !directions[event.key]) return;
        event.preventDefault();
        const rect = this.launcher.getBoundingClientRect(), delta = directions[event.key];
        this.moveLauncher(rect.left + delta[0], rect.top + delta[1], true), this.savePosition();
      }, options), this.viewportChanged = () => {
        this.savedPosition ? this.restorePosition() : this.fitPanel();
      }, window.visualViewport?.addEventListener("resize", this.viewportChanged, options), window.visualViewport?.addEventListener("scroll", this.viewportChanged, options), this.savedPosition && this.restorePosition();
    }
    viewportBounds() {
      const viewport = window.visualViewport;
      return { left: (viewport?.offsetLeft || 0) + 16, top: (viewport?.offsetTop || 0) + 16, width: viewport?.width || innerWidth, height: viewport?.height || innerHeight };
    }
    moveLauncher(x, y, remember) {
      const view = this.viewportBounds(), rect = this.launcher.getBoundingClientRect(), travelX = Math.max(0, view.width - 32 - rect.width), travelY = Math.max(0, view.height - 32 - rect.height), left = Math.min(Math.max(x, view.left), view.left + travelX), top = Math.min(Math.max(y, view.top), view.top + travelY);
      this.style.left = left + "px", this.style.top = top + "px", this.style.bottom = "auto", this.style.right = "auto", remember && (this.savedPosition = { x: travelX ? (left - view.left) / travelX : 0, y: travelY ? (top - view.top) / travelY : 0 }), this.fitPanel();
    }
    restorePosition() {
      const view = this.viewportBounds(), rect = this.launcher.getBoundingClientRect();
      this.moveLauncher(view.left + this.savedPosition.x * Math.max(0, view.width - 32 - rect.width), view.top + this.savedPosition.y * Math.max(0, view.height - 32 - rect.height), false);
    }
    savePosition() {
      try {
        localStorage.setItem("suri-ava-position-v2", JSON.stringify(this.savedPosition));
      } catch {
      }
    }
    fitPanel() {
      if (this.panel.hidden) return;
      const view = this.viewportBounds(), rect = this.launcher.getBoundingClientRect(), width = Math.min(380, Math.max(0, view.width - 32)), height = Math.min(innerWidth <= 600 ? 570 : 590, Math.max(0, view.height - 32)), left = Math.max(view.left, Math.min(rect.left, view.left + view.width - 32 - width));
      let top = rect.top - height - 12;
      top < view.top && (top = rect.bottom + 12 + height <= view.top + view.height - 32 ? rect.bottom + 12 : view.top + (view.height - 32 - height) / 2), Object.assign(this.panel.style, { position: "fixed", left: left + "px", top: top + "px", bottom: "auto", width: width + "px", height: height + "px", animation: "none" });
    }

    welcome() {
      this.log.replaceChildren();
      this.transcript = [];
      this.saveState();
      this.message('assistant', HELLO, [], false);
      const suggestions = document.createElement('div');
      suggestions.className = 'suggestions';
      for (const [label, question] of QUESTIONS) {
        const button = document.createElement('button');
        button.type = 'button'; button.textContent = label;
        button.addEventListener('click', () => { this.input.value = question; this.submit(); });
        suggestions.append(button);
      }
      this.log.append(suggestions);
    }

    toggle(open, focus = true) {
      this.panel.hidden = !open;
      this.fitPanel();
      this.launcher.setAttribute('aria-expanded', String(open));
      if (focus && open) this.closeButton.focus({ preventScroll: true });
      else if (focus) this.launcher.focus({ preventScroll: true });
      this.saveState();
    }

    message(role, text, sources = [], record = true) {
      if (role !== 'user') this.stopLoading();
      if (record) {
        this.transcript.push({ role, text: String(text).slice(0, 2000), sources: sources.slice(0, 5).map((source) => ({ url: String(source.url), title: String(source.title || '').slice(0, 80), retrievedAt: String(source.retrievedAt || '') })) });
        this.transcript.splice(0, Math.max(0, this.transcript.length - MAX_SAVED));
        this.saveState();
      }
      const row = document.createElement('div');
      row.className = `message ${role}`;
      const label = document.createElement('span'); label.className = 'message-label'; label.textContent = role === 'user' ? 'You' : role === 'notice' ? 'Chat update' : 'Ava';
      const body = document.createElement('p'); body.textContent = String(text).slice(0, 2000);
      row.append(label, body);
      const links = document.createElement('div'); links.className = 'sources';
      const seen = new Set();
      for (const source of sources.slice(0, 5)) {
        try {
          const url = new URL(source.url);
          if (url.protocol !== 'https:' || !['www.suriofficial.com', 'suriofficial.com'].includes(url.hostname) || url.username || url.password || url.port || seen.has(url.href)) continue;
          seen.add(url.href);
          const link = document.createElement('a'); link.href = url.href; link.target = '_blank'; link.rel = 'noopener noreferrer';
          link.textContent = TITLES[url.pathname.split('/').pop()] || (url.pathname === '/' ? 'Suri website' : String(source.title || 'View source').slice(0, 80));
          const checked = new Date(source.retrievedAt);
          if (Number.isFinite(checked.getTime())) link.title = `Source checked ${checked.toLocaleString()}`;
          links.append(link);
        } catch { /* Only verified store links are displayed. */ }
      }
      if (links.childNodes.length) row.append(links);
      this.log.append(row);
      while (this.log.children.length > 40) this.log.firstElementChild.remove();
      this.log.scrollTop = this.log.scrollHeight;
    }

    startLoading() {
      this.stopLoading();
      const row = document.createElement('div');
      row.className = 'loading';
      // One stable screen-reader announcement lives in .status; decorative updates stay quiet.
      row.setAttribute('aria-hidden', 'true');
      row.innerHTML = '<span class="loading-mark"></span><span class="loading-text"></span>';
      const mark = row.querySelector('.loading-mark');
      const label = row.querySelector('.loading-text');
      const labels = ['Thinking...', 'Considering...', 'Pondering...'];
      // Request text presentation: iOS otherwise renders this star as a green emoji.
      const textStar = '✳\uFE0E';
      const marks = ['·', '✢', textStar, '✶', '✻', '✽', '✻', '✶', textStar, '✢'];
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const started = performance.now();
      const renderFrame = () => {
        const elapsed = performance.now() - started;
        const text = labels[Math.floor(elapsed / 3200) % labels.length];
        const phase = elapsed % 3200;
        mark.textContent = motion.matches ? textStar : marks[Math.floor(elapsed / 100) % marks.length];
        // The reference reveals the new word left-to-right with a block cursor
        // and a brief flicker in its newest letters, then holds the complete word.
        if (motion.matches || phase >= 900) {
          label.textContent = text;
          return;
        }
        const count = Math.floor(phase / 900 * text.length);
        const revealed = Array.from(text.slice(0, count));
        for (let index = Math.max(0, count - 2); index < count; index++) {
          const frame = Math.floor(phase / 60 + index) % 4;
          if (frame === 0) revealed[index] = '_';
          else if (frame === 1) revealed[index] = '·';
        }
        label.textContent = revealed.join('') + '█';
      };
      renderFrame();
      this.loadingRow = row;
      this.log.append(row);
      this.log.scrollTop = this.log.scrollHeight;
      this.loadingTimer = setInterval(renderFrame, 60);
    }

    stopLoading() {
      clearInterval(this.loadingTimer);
      this.loadingTimer = null;
      this.loadingRow?.remove();
      this.loadingRow = null;
      if (this.status?.classList.contains('sr-only')) this.status.textContent = '';
    }

    setBusy(value, showLoading = true) {
      this.busy = value;
      this.input.disabled = value || this.endedForSecurity; this.send.disabled = value || this.endedForSecurity; this.reset.disabled = value;
      for (const button of this.log.querySelectorAll('.suggestions button')) button.disabled = value;
      const loading = value && showLoading && !this.endedForSecurity;
      if (loading) this.startLoading();
      else this.stopLoading();
      this.status.classList.toggle('sr-only', loading);
      this.status.textContent = this.endedForSecurity ? 'Chat ended for security. Select New chat to start again.' : value ? (showLoading ? 'Ava is thinking. Your reply is on its way.' : 'Starting a new chat…') : '';
    }

    async request(body) {
      const response = await fetch(this.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer', signal: this.abort?.signal, body: JSON.stringify(body) });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        const error = new Error(data.error || 'Ava is temporarily unavailable. Please try again or contact the Suri team.');
        error.status = response.status;
        throw error;
      }
      return data;
    }

    async submit() {
      const question = this.input.value.trim();
      if (this.busy || this.endedForSecurity || !question || question.length > 1000) return;
      this.log.querySelector('.suggestions')?.remove();
      const sensitive = window.SuriAvaSecurity.paymentDisclosure(question);
      if (sensitive) this.endedForSecurity = true;
      this.message('user', sensitive ? '[Payment details removed]' : question);
      this.input.value = '';
      await this.exchange(sensitive, async () => {
        if (!this.session || this.session.expires <= Date.now()) {
          this.session = null;
          const started = await this.request({ action: 'start', channel: 'chat', historyNoticeDays: 90 });
          if (typeof started.token !== 'string' || !Number.isSafeInteger(started.turn)) throw new Error('Ava could not start a conversation. Please try again.');
          this.session = { token: started.token, turn: started.turn, expires: Date.now() + 14 * 60 * 1000 };
        }
        const turn = this.session.turn;
        this.pending = true; this.saveState();
        return [turn, await this.request({ action: 'ask', token: this.session.token, turn, question: sensitive ? '[Payment details removed]' : question, securityStop: sensitive, ...this.pageContext() })];
      });
    }

    // Collects a reply that was still pending when the shopper moved to another page.
    resume() {
      return this.exchange(false, async () => [this.session.turn, await this.request({ action: 'poll', token: this.session.token })], true);
    }

    async exchange(sensitive, send, resuming = false) {
      // A back/forward-cache return reloads saved state and starts a new generation;
      // an older exchange that wakes up afterwards must not touch the reloaded state.
      const generation = this.generation, current = () => generation === this.generation;
      const abort = new AbortController();
      this.abort = abort;
      this.exchanging = true;
      this.setBusy(true);
      const timeout = setTimeout(() => abort.abort(), 60000);
      try {
        let [turn, data] = await send();
        let polls = 0;
        while (data.pending) {
          // Most answers finish within 3-8 s, so check twice a second at first, then once a second.
          await new Promise((resolve) => setTimeout(resolve, polls++ < POLL_FAST_COUNT ? POLL_FAST : POLL_SLOW));
          if (!current()) return;
          if (abort.signal.aborted) throw new Error('Ava took too long to reply. Please start a new chat or contact the Suri team.');
          data = await this.request({ action: 'poll', token: this.session.token });
        }
        if (!current()) return;
        // The question never reached Ava before the previous page closed.
        if (resuming && data.turn === turn) return;
        if (!data.reply || typeof data.reply.text !== 'string' || !Number.isSafeInteger(data.turn) || data.turn !== turn + 1) throw new Error('The reply could not be verified. Please start a new chat.');
        this.session.turn = data.turn;
        this.pending = false;
        this.message('assistant', data.reply.text, Array.isArray(data.reply.sources) ? data.reply.sources : []);
        if (data.ended || data.reply.disposition === 'security_ended') {
          this.endedForSecurity = true; this.session = null;
        }
        if (this.session && ['goodbye', 'emergency'].includes(data.reply.disposition)) {
          const token = this.session.token;
          this.session = null;
          await this.request({ action: 'end', token }).catch(() => {});
        }
      } catch (error) {
        // Navigating away cancels requests before pagehide fires. Wait briefly before treating a
        // network failure as an error: an unloading page never resumes, and the next page collects the reply.
        if (!error.status) await new Promise((resolve) => setTimeout(resolve, NETWORK_GRACE));
        if (!current() || this.leaving) return;
        this.pending = false;
        if (sensitive) this.message('assistant', window.SuriAvaSecurity.securityReply());
        else this.message('notice', error.name === 'AbortError' ? 'Ava took too long to reply. Please try a new chat or contact the Suri team.' : error.message || 'Ava could not connect. Please try again or contact the Suri team.');
        if (this.session) {
          const token = this.session.token;
          this.session = null;
          if (![401, 410].includes(error.status) && !abort.signal.aborted) await this.request({ action: 'end', token }).catch(() => {});
        }
      } finally {
        clearTimeout(timeout);
        if (current()) {
          this.exchanging = false;
          if (!this.leaving) {
            this.pending = false;
            this.setBusy(false);
            this.saveState();
            if (!this.panel.hidden) this.input.focus({ preventScroll: true });
          }
        }
      }
    }

    async clear() {
      if (this.busy) return;
      const old = this.session;
      this.session = null;
      this.pending = false;
      this.endedForSecurity = false; this.setBusy(false);
      this.input.value = ''; this.welcome();
      if (old) {
        this.abort = new AbortController();
        const timer = setTimeout(() => this.abort?.abort(), 5000);
        this.setBusy(true, false);
        try { await this.request({ action: 'end', token: old.token }); }
        catch { this.message('notice', 'Chat cleared here. Your previous server session will expire automatically.', [], false); }
        finally { clearTimeout(timer); this.setBusy(false); }
      }
      this.input.focus({ preventScroll: true });
    }
  }
  customElements.define('suri-ava-chat', AvaChat);
})();
